import {
  query,
  collection,
  updateDoc,
  doc,
  deleteDoc,
  onSnapshot,
  Unsubscribe,
  setDoc,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import { IService } from "../../models/three-sixty-feedback-models/Services";
import AppStore from "../../stores/AppStore";
import AppApi from "../AppApi";

export default class ServiceApi {
  constructor(private api: AppApi, private store: AppStore) {}

  private generalPath() {
    return "ServiceTemplate";
  }

  async create(object: IService) {
    const path = this.generalPath();
    if (!path) return;

    const itemRef = doc(collection(db, path));
    object.id = itemRef.id;
    try {
      await setDoc(itemRef, object, { merge: true });
    } catch (error) {}
  }

  async update(object: IService) {
    const path = this.generalPath();
    if (!path) return;

    try {
      await updateDoc(doc(db, path, object.id), {
        ...object,
      });
      this.store.services.load([object]);
    } catch (error) {
      console.log(error);
    }
  }

  async delete(object: IService) {
    const path = this.generalPath();
    if (!path) return;

    try {
      await deleteDoc(doc(db, path, object.id));
      this.store.services.remove(object.id);
    } catch (error) {}
  }

  async getAll() {
    this.store.value.removeAll();

    const path = this.generalPath();
    if (!path) return;

    const $query = query(collection(db, path));

    return await new Promise<Unsubscribe>((resolve, reject) => {
      const unsubscribe = onSnapshot(
        $query,
        (querySnapshot) => {
          const object: IService[] = [];
          querySnapshot.forEach((doc) => {
            object.push({ id: doc.id, ...doc.data() } as IService);
          });
          this.store.services.load(object);
          resolve(unsubscribe);
        },
        (error) => {
          reject();
        }
      );
    });
  }
}
